<template>
	<section class="small-12 propertyListingsPage unitsListing" v-if="property">
		<section class="small-12 columns pageTitle flex justify-center">
			<div class="small-12 flex vertical-align">
				<div class="small-12 large-3 columns">
					<h1 class="small-12 flex vertical-align">
						Units Overview
					</h1>
				</div>
				<div class="small-12 large-9 columns searchContainer">
					<ul class="small-12 flex justify-right vertical-align">
						<li class="addMenu">
							<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddUnitMenu()">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Add Unit
							</a>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<div class="small-12 flex listingsContainer">
			<section class="small-12 large-8 flex justify-center listings border-right listingsContainerWrap">
				<div class="small-12 columns" style="margin-top:30px;">
					<ul class="small-12 columns float-left">
						<li class="small-12 featureWidget">
							
						</li>
					</ul>
				</div>
				<div class="small-12 columns listingsTitle animated fadeIn">
					<div class="small-12 flex vertical-align">
						<h3 class="small-3 columns flex vertical-align">
							Units 
						</h3>
						<div class="small-9 columns searchContainer" style="margin-bottom:20px;">
							<ul class="small-12 flex justify-right vertical-align">
								<li class="reportsMenu">
									<a ref="unitsFilters" class="flex justify-center vertical-align borderRadius4" @click="showFilterDropdownMenu()">
										<i class="material-icons-outlined chartIcon flex justify-center vertical-align borderRadius4">filter_alt</i>
										Filter
									</a>
									<div ref="unitsFiltersMenu" class="auto filterDropdownMenu animated fadeIn" v-show="show_filter_menu_dropdown">
										<div class="small-12 filterWrap borderRadius4">
											<div class="small-12 filterMenuLabel">
												<p>Quick Filters</p>
											</div>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('rented')">
												<i class="material-icons-outlined">verified_user</i>
												Rented
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('available')">
												<i class="material-icons-outlined">pending</i>
												Available
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="viewAllListings()">
												<i class="material-icons-outlined">list</i>
												View All
											</a>
										</div>
									</div>
								</li>
								<li class="search show small-12 large-4">
									<input class="border" type="text" placeholder="Search by Resident" v-model="search_query" @input="searchResults($event)">
									<i class="material-icons-outlined">search</i>
								</li>
								<li class="addMenu">
									<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddUnitMenu()">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Unit
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="small-12 columns listingsTable inPage">
					<div class="small-12 columns head">
						<ul class="small-12 flex vertical-align">
							<li class="small-12 columns large-2 flex vertical-align">
								<p class="flex vertical-align">
									Number
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Status
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Monthly Rent
								</p>
							</li>
							<li class="small-12 large-6 columns flex vertical-align end">
								<p class="flex vertical-align">
									Resident
								</p>
							</li>
						</ul>
					</div>
					<div class="small-12 columns body">
						<div class="small-12" v-if="search_query">
							<div class="small-12 flex listingsDiv" v-if="queried_results.length > 0">
								<unit :unit="unit" v-for="(unit, index) in queried_results" :key="index"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No units have been found matching that number.
										</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="small-12" v-if="!search_query && filter_query">
							<div class="small-12 flex listingsDiv" v-if="queried_results.length > 0">
								<unit :unit="unit" v-for="(unit, index) in queried_results" :key="index"/>
							</div>
							<div class="small-12 flex listingsDiv" v-if="queried_results.length == 0">
								<div class="small-12 emptyResults flex justify-center">
									<picture class="small-12 flex justify-center">
										<img width="120" :src="empty_image" alt="Nestd Logo in a House">
									</picture>
									<h6 class="small-12 text-center">
										0 results found
									</h6>
									<p class="small-12 text-center">
										No units match your selected filter.
									</p>
								</div>
							</div>
						</div>
						<div class="small-12" v-if="!search_query && !filter_query">
							<div class="small-12 flex listingsDiv" v-if="units && units.length > 0">
								<unit :unit="unit" v-for="(unit, index) in units" :key="index"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No units have been added to this property yet.
										</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<user-footer/>
			</section>
			<section class="small-12 large-4 columns flex overviewPanel" v-bind:class="{ active: open_add_unit_menu }">
				<div class="small-12">
					<div class="small-12 panelBody">
						<potential-actual :property="property" :units="units" />
						<unit-mix-breakdown :property="property" :units="units" />
					</div>
				</div>
				<add-unit-menu :menu_action="open_add_unit_menu" :property="property" :company="company" @closeAddUnitMenu="closeAddUnitMenu"/>
			</section>
		</div>
	</section>
</template>

<script>

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import AddUnitMenu from '@/components/property/units/AddUnitMenu.vue'
	import Unit from '@/components/property/units/Unit.vue'
	import PotentialActual from '@/components/property/units/PotentialActual.vue'
	import UnitMixBreakdown from '@/components/property/units/UnitMixBreakdown.vue'

	// Import the events
	import { BindPropertyUnits } from '@/events/units/BindPropertyUnits' 
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitsListing',

		/*
		**  Register the components
		*/

		components: {

			UserFooter,
			AddUnitMenu,
			Unit,
			PotentialActual,
			UnitMixBreakdown

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BindPropertyUnits

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			open_add_unit_menu: false,
			show_filter_menu_dropdown: false,
			search_query: '',
			filter_query: null,
			queried_results: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					/*
					**  Bind to the units
					**  @method: @Events/Units/BindPropertyUnits
					*/

					if (property) this.bindPropertyUnitsHandler(property.id);

				}

			}

		},

		/*
        ** Do this first
        */

        created() {

        	window.addEventListener('click', this.closeFilterMenu);

        },

		beforeDestroy() {

			window.removeEventListener('click', this.closeFilterMenu);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			openAddUnitMenu: function() {

				// Open the menu
				this.open_add_unit_menu = true;

			},

			closeAddUnitMenu: function(value) {

				// Close the menu
				this.open_add_unit_menu = false;

			},

			showFilterDropdownMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					if (!this.show_filter_menu_dropdown) {

						this.show_filter_menu_dropdown = true;

					} else {

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Show the Filter Dropdown Menu',
						errorType: 'Application',
						section: 'Units Overview',
						uid: '4F5UqWDBVEnBWnqOVeXF',
						error: e
					});

				}

			},

			closeFilterMenu(evt) {

				try {

					let parentElement = evt.target.parentElement;

					/*
					**  If menu wasn't clicked
					*/

					if (evt.target !== this.$refs['unitsFiltersMenu'] && evt.target !== this.$refs['unitsFilters'] && parentElement !== this.$refs['unitsFilters']) {

						/*
						**  Set the prop
						**  @prop: @here
						*/

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to close the units filter menu',
						errorType: 'Application',
						section: 'Units Overview',
						uid: 'SyDUDkWs7d581mATxAI7',
						error: e
					});

				}

		    },

			searchResults: function (event) {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the data
					*/

					if (event) {

						/*
						**  Set the vars
						*/

						if (this.units.length > 0) {

							return this.units.filter((item)=>{
								
								if (item.attributes.resident.first_name.toLowerCase().includes(this.search_query.toLowerCase()) || item.attributes.resident.last_name.toLowerCase().includes(this.search_query.toLowerCase())) {

									return this.queried_results.push(item);

								}

							});

						} else {

							/*
							**  Set the full list of rents
							*/

							return this.queried_results = this.units;

						}

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Search for a Unit.',
						errorType: 'Application',
						section: 'Units Overview',
						uid: 'uVzuco5TjcqIPGasTOgV',
						error: e
					});

				}

			},

			viewAllListings: function() {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.search_query = null;
					this.filter_query = null;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to View All of the Units Listings',
						errorType: 'Application',
						section: 'Units Overview',
						uid: 'iLMhd4qrExxedpdqWTkk',
						error: e
					});

				}

			},

			filterBy: function(value) {

				try {

					/*
					**  Set the search & filter queries
					**  @prop: @here
					*/
					
					this.search_query = null;
					this.filter_query = value;

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the results
					**  @prop: @here
					*/

					if (this.units.length > 0) {

						return this.units.filter((item)=>{

							/*
							**  If rented
							*/

							if (value == 'rented' && !item.attributes.available) return this.queried_results.push(item);

							/*
							**  If available
							*/

							if (value == 'available' && item.attributes.available) return this.queried_results.push(item);

						});

					} else {

						/*
						**  Set the full list of rents
						*/

						return this.queried_results = this.units;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to apply a status filter when filtering units.',
						errorType: 'Application',
						section: 'Units Overview',
						uid: 'hbv9y1GBEeHQoTDaqKXy',
						error: e
					});

				}

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>